/* eslint-disable jsdoc/require-jsdoc */
import React, { ReactElement, useEffect, useState } from 'react';
import DashboardWidgetContainer from '../../components/DashboardWidgetContainer';
import HistogramWidget from '../../components/histogram/HistogramWidget';
import { DeviceType, ParametersType, TimeSpan } from '../../constants/telosair-interfaces';
import Deque from '../../classes/deque';

interface HistogramContainerProps {
  expanded: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<'map' | 'histogram'>>;
  extendedLabel: string;
  timeSpan: TimeSpan;
  onChangeParameter: (value: ParametersType[]) => void;
  lineChartGraphData: Record<ParametersType, Deque>;
  loading: boolean;
  type: DeviceType;
}

export default function HistogramContainer({
  expanded,
  setExpanded,
  extendedLabel,
  timeSpan,
  onChangeParameter,
  lineChartGraphData,
  loading,
  type
}: HistogramContainerProps): ReactElement {
  const [uiChange, setUiChange] = useState(false);
  useEffect(() => {
    setUiChange(true);
    setTimeout(() => {
      setUiChange(false);
    }, 100);
  }, [expanded]);
  return (
    <DashboardWidgetContainer
      name="histogram"
      title="Time Series"
      expanded={expanded}
      setExpanded={setExpanded}
      extendedLabel={extendedLabel}
    >
      <HistogramWidget
        timeSpan={timeSpan}
        extendedLabel={extendedLabel}
        lineChartGraphData={lineChartGraphData}
        onChangeParameter={onChangeParameter}
        loading={loading || uiChange}
        expanded={expanded}
        type={type}
      />
    </DashboardWidgetContainer>
  );
}
